import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";
import Datetime from "react-datetime";
import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/Redeem";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import SearchComponent from "components/Search/AutoCompletePatientForCampaign.jsx";
import Slide from "@material-ui/core/Slide";

import GridContainer from "components/Grid/GridContainer.jsx";

import {
    mappingUI,
    dashboardRouter,
    isClinicMasterOrClinic,
    getClinicUserId, getDateConverter,
    getReportTypes, clinicmaster_id, timing
} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};

class ReCampaign extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            start_date: "",
            end_date: "",
            clinic_id: "",
            doctor_id: "",
            slot: "",
            date: "",
            Content: "",
            patientId: "",
            type: "",
            open: true,
            alert: null,
            status: "",
            comments: "",
            selectTemplate: 0,
            patients: [],
            laterTime: false,
            userSegment: [],
            userSelectedSegment: null,
            send_to_all: false,
            previewModal: false,
            classicModal: false,
            name: "",
            campaignName: "",
            tagsUser: []
        };
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this);
        this.onChangeContent = this.onChangeContent.bind(this);
        this.createCampaignApi = this.createCampaignApi.bind(this);
        this.saveUserSegment = this.saveUserSegment.bind(this)
    }


    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };


    componentDidMount() {
        api.getCampaign({
            "_id": this.props.id.match.params.id,
        }).then((result) => {
            this.setState({campaign: result ? result.data.data : []}, () => {
                this.setState({
                    Content: result.data.data.content,
                    send_to_all: false,
                    channel: result.data.data.push && result.data.data.sms ? "all" : result.data.data.sms ? "sms" : "notification",
                    patients: result.data.data.user_tags,
                    tags: result.data.data.user_tags,
                    clinic_id: result.data.data.clinic_id,
                    clinic_master_id: result.data.data.clinic_master_id
                }, () => {
                    api.getUserCampaignSegments({
                        "clinic_id": getClinicUserId() !== "" ? getClinicUserId() : this.state.clinic_id ? this.state.clinic_id : "",
                        "clinic_master_id": clinicmaster_id() !== "" ? clinicmaster_id() : this.state.clinic_master_id ? this.state.clinic_master_id : "",
                    }).then((result) => {
                        this.setState({userSegment: result ? result.data.data : []});
                    }).catch((err) => {
                    });
                })
            });
        }).catch((err) => {
        });

    }

    getUserInfo(id) {
        api.getUserCampaignSegments({
            "_id": id ? id : this.state.userSegment[0]._id
        }).then((result) => {
            this.setState({userSelectedSegment: result ? result.data.data : []});
        }).catch((err) => {
        });
    }


    saveUserSegment() {
        if (this.state.name !== "") {
            var postBody = {
                "users": this.state.send_to_all ? [] : this.state.patients.map(item => {
                    return item.id
                }),
                "name": this.state.name,
                "clinic_id": getClinicUserId() !== "" ? getClinicUserId() : this.state.clinic_id ? this.state.clinic_id : "",
                "clinic_master_id": clinicmaster_id() !== "" ? clinicmaster_id() : this.state.clinic_master_id ? this.state.clinic_master_id : ""

            };
            api.createUserCampaignSegments(postBody).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    var msgcolor = {message: "Segment Created Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.setState({alert: null})
                }
            });
        }
    }

    SaveUserSegment() {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Save Segment"}</DialogTitle>
                    <DialogActions style={{margin: '8px auto'}}>
                        <form noValidate autoComplete="off" style={{padding: '0px 50px '}}>
                            <GridContainer>
                                <TextField
                                    id="standard-name"
                                    label="Name"
                                    fullWidth
                                    onChange={e => this.onChangeText(e, 'name')}
                                    margin="normal"
                                />
                            </GridContainer>
                        </form>
                    </DialogActions>
                    <DialogActions style={{margin: '8px auto'}}>
                        <GridContainer> <Button color="danger" onClick={() => {
                            this.saveUserSegment()
                        }}>
                            Save
                        </Button>
                            <Button onClick={this.hideAlert}>
                                Cancel
                            </Button></GridContainer>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    SaveCampaignTemplate() {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Save Template"}</DialogTitle>
                    <DialogActions style={{margin: '8px auto'}}>
                        <form noValidate autoComplete="off" style={{padding: '0px 50px '}}>
                            <GridContainer>
                                <TextField
                                    id="standard-name"
                                    label="Name"
                                    fullWidth
                                    onChange={e => this.onChangeText(e, 'campaignName')}
                                    margin="normal"
                                />
                            </GridContainer>
                        </form>
                    </DialogActions>
                    <DialogActions style={{margin: '8px auto'}}>
                        <GridContainer> <Button color="danger" onClick={() => {
                            this.createCampaignTemplate()
                        }}>
                            Save
                        </Button>
                            <Button onClick={this.hideAlert}>
                                Cancel
                            </Button></GridContainer>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    onChangeText(e, name) {
        this.setState({[name]: e.target.value})
    }

    getSuggestionValue = (suggestion) => {
        this.setState({
            patients: suggestion,

        });
    };

    hideAlert() {
        this.setState({alert: null})
    }

    CreateAlert(id) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Change Status"}</DialogTitle>
                    <div style={{padding: '0 20px'}}>
                        <h6>Select Status:</h6>
                        <input type="radio" onChange={this.onChangeStatus}
                            // checked={this.state.status === "Follow up"}
                               value={"Follow up"} name="status"/>Follow up<br/>
                        <input type="radio" onChange={this.onChangeStatus} name="status"
                            // checked={this.state.status === "Accepted"}
                               value={"Accepted"}/>Accepted<br/>
                        <input type="radio" onChange={this.onChangeStatus} name="status"
                            // checked={this.state.status === "Rejected"}
                               value={"Rejected"}/>Rejected<br/>

                        <h6>Comments:</h6>
                        <textarea name="comments"
                                  onChange={e => this.setState({comments: e.target.value})}/>

                    </div>
                    <DialogActions style={{margin: '8px auto'}}>
                        <Button color="info" onClick={() => {
                            this.changeStatusApi(id)
                        }}>
                            Change
                        </Button>
                        <Button onClick={this.hideAlert}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    deleteRecord(id) {
        var postBody = {"_id": id, "updated_object": {}};
        api.deleteReport(postBody)
            .then(json => {

                this.setState({alert:null});
          //      window.location.reload();
            });
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data, clinicsData, doctorsData, campaign} = this.state;
        const {classes} = this.props;
        return (
            <div>
                {this.state.alert}
                <Grid container>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" text>
                                <CardText color="info">
                                    <GridContainer>
                                        <GridItem>
                                            <LocalHospital/>
                                        </GridItem>

                                        <GridItem>
                                            <h4 className={classes.cardTitleWhite}>Campaign</h4>
                                        </GridItem>
                                    </GridContainer>
                                </CardText>
                            </CardHeader>
                            <CardBody className={classes.justifyContentCenter} style={{justifyContent: "center"}}>
                                <GridContainer>
                                    <GridItem xs={12} md={3}>
                                    </GridItem>
                                    <GridItem xs={12} md={6}>
                                        <br/>
                                        <GridContainer className={classes.justifyContentCenter}>

                                            <GridItem xs={12}>
                                                 <span className="cust-circ1">
                                            <svg viewBox="0 0 120 120" className="css-12ta9cw e12lgfev0"><rect x="0"
                                                                                                               y="0"
                                                                                                               width="120"
                                                                                                               height="120"
                                                                                                               rx="15"
                                                                                                               ry="15"
                                                                                                               fill="#39abc1"/><text
                                                x="50%" y="50%" fontSize="65" textAnchor="middle" fill="#FFFFFF"
                                                style={{"dominantBaseline": "central"}}>1</text></svg>
                                        </span>

                                                <h4 style={{display: "inline-block"}}>Select and Add Patients:</h4>


                                                <Checkbox
                                                    checked={this.state.send_to_all}
                                                    onChange={(e) => this.onChangeCheckbox(e)}
                                                    value="checkedA"
                                                    color={"primary"}
                                                    inputProps={{
                                                        'aria-label': 'primary checkbox',
                                                    }}
                                                />
                                                <label>All Patients</label>
                                                {/*<input*/}
                                                {/*onChange={(e) => this.onChangeCheckbox(e)}*/}
                                                {/*type="checkbox"/>All Patients*/}

                                            </GridItem>
                                            {/*<GridItem xs={12} sm={12} md={4}>*/}
                                            {/**/}
                                            {/*</GridItem>*/}
                                            <GridItem xs={12}>
                                                <div style={{paddingLeft: 20}}>
                                                    {this.state.send_to_all ?
                                                        <input className="inputSearchPatient"
                                                               placeholder="Search Patient"
                                                               disabled={true}/> :
                                                        <SearchComponent className={styles.AutoCompleteClass}
                                                                         style={{paddingLeft: 20}}
                                                                         clinic={this.state.clinic_id}
                                                                         clinicmaster_id={this.state.clinic_master_id}
                                                                         tagsUser={this.state.tagsUser}
                                                                         getSuggestionValue={this.getSuggestionValue}/>}
                                                </div>
                                                <br/>
                                                <br/>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer className={classes.justifyContentCenter}>

                                            <GridItem xs={12} md={5}>

                                                <span className="cust-circ1">
                                            <svg viewBox="0 0 120 120" className="css-12ta9cw e12lgfev0"><rect x="0"
                                                                                                               y="0"
                                                                                                               width="120"
                                                                                                               height="120"
                                                                                                               rx="15"
                                                                                                               ry="15"
                                                                                                               fill="#39abc1"/><text
                                                x="50%" y="50%" fontSize="65" textAnchor="middle" fill="#FFFFFF"
                                                style={{"dominantBaseline": "central"}}>2</text></svg>
                                        </span>
                                                <h4>Channel</h4>

                                            </GridItem>
                                            <GridItem>
                                                <div className="padding-10"><RadioGroup
                                                    aria-label="Channel"
                                                    name="gender1"
                                                    className={classes.group}
                                                    value={this.state.channel}
                                                    onChange={e => this.onChangeRadio(e)}>
                                                    <FormControlLabel value="all" control={<Radio color="primary"/>}
                                                                      label="All Channel"/>
                                                    <FormControlLabel value="notification"
                                                                      control={<Radio color="primary"/>}
                                                                      label="Notification"/>
                                                    <FormControlLabel value="sms" control={<Radio color="primary"/>}
                                                                      label="SMS"/>
                                                </RadioGroup></div>
                                                <br/>
                                                <br/>
                                                {/*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*/}
                                                {/*<input onChange={e => this.onChangeRadio(e)}*/}
                                                {/*type="radio" name="channel"*/}
                                                {/*value={"all"}/> All*/}
                                                {/*Channel&nbsp;&nbsp;&nbsp;&nbsp;*/}
                                                {/*<input onChange={e => this.onChangeRadio(e)} type="radio" name="channel"*/}
                                                {/*value={"notification"}/>*/}
                                                {/*Notification&nbsp;&nbsp;&nbsp;&nbsp;*/}
                                                {/*<input onChange={e => this.onChangeRadio(e)} value="sms" type="radio"*/}
                                                {/*name="channel"/> SMS*/}

                                                {/*<br/>*/}
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer className={classes.justifyContentCenter}>
                                            <GridItem xs={12} md={4}>
                                    <span className="cust-circ1"><svg viewBox="0 0 120 120"
                                                                      className="css-12ta9cw e12lgfev0"><rect
                                        x="0" y="0"
                                        width="120"
                                        height="120"
                                        rx="15"
                                        ry="15"
                                        fill="#39abc1"/><text
                                        x="50%" y="50%" font-size="65" text-anchor="middle" fill="#FFFFFF"
                                        style={{"dominantBaseline": "central"}}>3</text></svg>
                                        </span>
                                                <h4 style={{display: 'flex'}}>Template</h4>

                                                <br/>
                                            </GridItem>
                                            <GridItem xs={12} md={6}>
                                                <TextField
                                                    id="standard-multiline-flexible"
                                                    label="Message"
                                                    multiline
                                                    rows="4"
                                                    value={this.state.Content}
                                                    onChange={e => this.onChangeContent(e)}
                                                    className={classes.textField}
                                                    margin="normal"
                                                    style={{width: '100%'}}
                                                />
                                                {/*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<textarea*/}
                                                {/*onChange={e => this.onChangeContent(e)}/>*/}
                                                {/*<br />*/}
                                            </GridItem>
                                        </GridContainer>
                                        {!this.state.laterTime ?
                                            <GridContainer className={classes.justifyContentCenter}>
                                                <GridItem xs={12} md={8}>
                                                    <h4><Checkbox tabIndex={-1}
                                                                  name="laterTime"
                                                                  onClick={(e) => this.checkLater(e)}
                                                                  checked={this.state.laterTime}
                                                    /> Schedule Later</h4>

                                                    <br/>
                                                </GridItem>
                                            </GridContainer> :  <GridContainer className={classes.justifyContentCenter}>
                                            <GridItem xs={12} md={4}>
                                    <span class="cust-circ1"><svg viewBox="0 0 120 120" class="css-12ta9cw e12lgfev0"><rect
                                        x="0" y="0"
                                        width="120"
                                        height="120"
                                        rx="15"
                                        ry="15"
                                        fill="#39abc1"/><text
                                        x="50%" y="50%" font-size="65" text-anchor="middle" fill="#FFFFFF"
                                        style={{"dominantBaseline": "central"}}>4</text></svg>
                                        </span>
                                                <h4 style={{display: 'flex'}}>Schedule</h4>

                                                <br/>
                                            </GridItem>
                                            <GridItem xs={12} md={6}>
                                                <Datetime
                                                    timeFormat={false}
                                                    defaultValue={new Date()}
                                                    value={this.state.date}
                                                    name="date"
                                                    id="appointment_date"
                                                    dateFormat={"DD MMMM, YYYY"}
                                                    closeOnSelect={true}
                                                    onChange={event => this.handleChangeStartDate(event)}
                                                    inputProps={{placeholder: "Appointment Date"}}/>
                                                {/*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<textarea*/}
                                                {/*onChange={e => this.onChangeContent(e)}/>*/}
                                                <br/>
                                                <FormControl   fullWidth
                                                               className={classes.selectFormControl}>

                                                <InputLabel
                                                    htmlFor="slot"
                                                    className={classes.selectLabel}>
                                                    Select Time
                                                </InputLabel>
                                                <Select
                                                    MenuProps={{
                                                        className: classes.selectMenu
                                                    }}
                                                    classes={{
                                                        select: classes.select
                                                    }}
                                                    value={this.state.slot}
                                                    onChange={this.onChangeSelect}
                                                    inputProps={{
                                                        name: "slot",
                                                        id: "slot"
                                                    }}
                                                >
                                                    <MenuItem disabled
                                                              classes={{
                                                                  root: classes.selectMenuItem
                                                              }}>Select Time</MenuItem>
                                                    {timing.map(item => {
                                                        return <MenuItem key={Math.random()}
                                                                         classes={{root: classes.selectMenuItem}}
                                                                         value={item.value}>
                                                            {item.value}  </MenuItem>
                                                    })}

                                                </Select>
                                            </FormControl>

                                    </GridItem>
                                        </GridContainer>}
                                        <br/>
                                    </GridItem>
                                    <GridItem xs={12} md={3}>
                                        <Button color="warning" onClick={() => {
                                            this.handleClickOpen("classicModal");
                                            this.getUserInfo();
                                        }}
                                        >
                                            <span style={{paddingLeft: 10}}>USE SAVED LIST</span>
                                        </Button><br/>
                                        {/*<Button color="info" onClick={() => {*/}
                                        {/*this.SaveUserSegment()*/}
                                        {/*}}>*/}
                                        {/*<span style={{padding: '0px 22px'}}>SAVE LIST</span>*/}
                                        {/*</Button>*/}
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                            <CardFooter className="centerDiv" style={{justifyContent: "center"}}>
                                {/*<GridItem xs={10} sm={3} md={2}>*/}
                                {/*<Button block color="warning"*/}
                                {/*onClick={() => {*/}
                                {/*this.SaveCampaignTemplate()*/}
                                {/*}}>Save</Button>*/}
                                {/*</GridItem>*/}
                                <GridItem xs={10} sm={3} md={2}>
                                    <Button block color="warning"
                                            onClick={() => this.createCampaignApi()}>Create</Button>
                                </GridItem>
                                <GridItem xs={10} sm={3} md={2}>
                                    <NavLink to={dashboardRouter(`/marketing/list`)}>
                                        <Button block color="grey">
                                            Cancel
                                        </Button>
                                    </NavLink>
                                </GridItem>
                            </CardFooter>
                        </Card>
                    </GridItem>
                </Grid>
                {this.state.userSegment.length > 0 ? <Dialog
                    maxWidth="lg"
                    classes={{
                        root: classes.center + " " + classes.modalRoot,
                        paper: classes.modal
                    }}
                    open={this.state.classicModal}
                    TransitionComponent={Transition}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description" keepMounted
                    onClose={() => this.handleClose("classicModal")}>
                    <DialogTitle id="alert-dialog-title">{"Select Segment"}</DialogTitle>
                    <DialogActions
                        style={{margin: '8px auto', width: '900px', textAlign: 'left', background: '#fff'}}>

                        <GridContainer style={{padding: '20px'}}>
                            <GridItem xs={4}>
                                {/*<AutoCompletePrescriptionTemplate clinic_id={this.state.clinic_id}*/}
                                {/*clinic_master_id={this.state.clinic_master_id}*/}
                                {/*setNotesValue={this.setNotesValue}*/}
                                {/*getReportTitleSuggestionValue={this.getReportTitleSuggestionValue}/>*/}

                            </GridItem>
                            <GridItem xs={8}>
                            </GridItem>
                            <Grid item xs={4} style={{height: '400px', overflow: 'scroll'}}>
                                <List>
                                    {this.state.userSegment.map((item, index) => {
                                        return <ListItem component="div"
                                                         onClick={() => {
                                                             this.setState({
                                                                 selectTemplate: index
                                                             });
                                                             // this.props.saveSearchPrescription(Math.random())
                                                         }}
                                                         style={this.state.selectTemplate === index ? {
                                                             background: '#39abc1',
                                                             color: 'white',
                                                             padding: '10px',
                                                         } : {
                                                             background: '#fff',
                                                             color: 'black',
                                                             padding: '10px',
                                                         }} key={index} divider autoFocus>
                                            {/*<ListItemText
                                             primary={item.remark !== "" ? item.remark : "No Remark"}
                                             secondary={item.created_at ? getDateConverter(item.created_at) : ""}
                                             >*/}
                                            <div style={{padding: "5px"}}>
                                                <GridContainer key={Math.random()}>
                                                    <GridItem xs={12}>
                                                        <h4>{item.name !== "" ? item.name : "No Name"}</h4>
                                                        <p>{item.created_at ? getDateConverter(item.created_at) : null}</p>
                                                    </GridItem>
                                                </GridContainer>
                                            </div>
                                            {/*</ListItemText>*/}
                                        </ListItem>
                                    })}
                                </List>
                            </Grid>
                            <Grid item xs={8}>
                                <Card component="div" style={{margin: '10px'}}>
                                    {/*<div style={{padding: "5px 15px"}}> */}
                                    <GridContainer key={Math.random()}>
                                        <GridItem xs={12}>

                                            <GridItem>
                                                <h4>
                                                    <strong>{this.state.userSegment[this.state.selectTemplate].name !== "" ? this.state.userSegment[this.state.selectTemplate].name : "No Name"}</strong>
                                                </h4>
                                            </GridItem>
                                            {this.state.userSelectedSegment !== null && this.state.userSelectedSegment.usersDetails.length > 0 ? this.state.userSelectedSegment.usersDetails.map(a => {
                                                return <div className="padding-10" key={Math.random()}>
                                                    <b>Name:</b> {a.name ? a.name : "No Name"}
                                                    &nbsp;&nbsp; <b>Mobile:</b>{a.contact ? a.contact : "No Contact"}
                                                    &nbsp;&nbsp;<b>Email:</b>{a.email ? a.email : "No Email"}</div>
                                            }) : null}

                                        </GridItem>
                                    </GridContainer>
                                    {/*</div> */}
                                    <CardFooter>
                                    </CardFooter>
                                </Card>
                            </Grid>

                        </GridContainer>

                    </DialogActions>
                    <DialogActions style={{margin: '8px auto'}}>

                        <GridContainer> <Button color="warning" onClick={() => {
                            this.setTemplate();
                            this.handleClose("classicModal")
                        }}>
                            Select
                        </Button>
                            <Button
                                onClick={() => this.handleClose("classicModal")}>
                                Cancel
                            </Button></GridContainer>
                    </DialogActions>
                </Dialog> : null}

            </div>
        );

    }

    onChangeCheckbox(e) {
        this.setState({send_to_all: e.target.checked})
    }

    onChangeRadio(e) {
        this.setState({channel: e.target.value})
    }

    onChangeContent(e) {
        this.setState({Content: e.target.value})
    }


    handleClickOpen(modal) {
        var x = [];
        x[modal] = true;
        this.setState(x);
    }


    handleClose(modal) {
        var x = [];
        x[modal] = false;
        this.setState(x);
    }


    setTemplate() {
        let data = this.state.userSelectedSegment.usersDetails && this.state.userSelectedSegment.usersDetails.length > 0 ? this.state.userSelectedSegment.usersDetails.map(item => {
            return item.contact
        }) : [];
        this.setState({
            // "patients": data.users ? data.users : [],
            "patients": data ? data : [],
            "alert": null,
            "tagsUser": data ? data : []
        })
    }

    createCampaignApi(id) {
        if (this.state.clinic_master_id !== "" && this.state.clinic_id !== "" && this.state.channel !== "") {
            var postBody = {
                "patients": this.state.send_to_all ? [] : this.state.patients.map(item => {
                    return item
                }),
                "send_to_all": this.state.send_to_all,
                "sms": this.state.channel === "sms" || this.state.channel === "all",
                "notification": this.state.channel === "notification" || this.state.channel === "all",
                "content": this.state.Content,
                "date_string": this.state.date,
                "local_start_time": this.state.slot,
                "clinic_id": getClinicUserId(),
                "clinic_master_id": clinicmaster_id(),
                data: {}
            };
            api.createCampaign(postBody).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    var msgcolor = {message: "Event Created Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/marketing/list`));
                }
            });
        }
    }

    createCampaignTemplate() {
        if (this.state.campaignName !== "") {
            var postBody = {
                "name": this.state.campaignName,
                "sms": this.state.channel === "sms" || this.state.channel === "all",
                "notification": this.state.channel === "notification" || this.state.channel === "all",
                "content": this.state.Content,
                "clinic_id": getClinicUserId() !== "" ? getClinicUserId() : this.state.clinic_id ? this.state.clinic_id : "",
                "clinic_master_id": clinicmaster_id() !== "" ? clinicmaster_id() : this.state.clinic_master_id ? this.state.clinic_master_id : "",

            };
            api.createCampaignTemplate(postBody).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    var msgcolor = {message: "Template Created Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    // this.props.id.history.push(dashboardRouter(`/dashboard`));
                }
            });
        }
    }

    handleChangeStartDate(event) {
        this.setState({
            date: (event).format('YYYY-MM-DD'),
        })
    }


    checkLater(e) {
        if (!e.target.checked) {
            this.setState({date: "", slot: "", trigger: true})
        }
        if (e.target.checked) {
            this.setState({trigger: false})
        }
        const state = this.state;
        state[e.target.name] = e.target.checked;
        this.setState(state);
    }

}

function Transition(props) {
    return <Slide direction="down" {...props} />;
}

export default withStyles(styles)(ReCampaign);



// WEBPACK FOOTER //
// ./src/components/Marketing/ReCampaign.jsx